import { request } from '@umijs/max';

export interface OssStsToken {
  accessKeyId: string;
  accessKeySecret: string;
  securityToken: string;
  expiration: string;
  region: string;
  bucket: string;
  endpoint: string;
  dirPrefix: string;
}

export async function getOssStsToken() {
  const res = await request<any>('/api/qn/oss/sts', { method: 'GET' } as any);
  const body = (res?.data ?? res) as any;
  if (body?.success === true && 'data' in body) return body.data as OssStsToken;
  return body as OssStsToken;
}

